module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-smart-edit card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, _vm._l((_vm.mutableItem), function(item, index) {
    return _c('div', {
      staticClass: "field"
    }, [_c('smart-edit-field', {
      attrs: {
        "name": index,
        "options": _vm.options
      },
      model: {
        value: (_vm.mutableItem[index]),
        callback: function($$v) {
          _vm.$set(_vm.mutableItem, index, $$v)
        },
        expression: "mutableItem[index]"
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18e5903c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/SmartEdit.vue
// module id = 2294
// module chunks = 1